<template>
    <button v-on:pointerdown="createRipple" class="c-btn">
        <slot></slot>
    </button>
</template>

<script>
export default {
    setup() {},

    methods: {
        createRipple(event) {
            const button = event.currentTarget;
            const circle = document.createElement("span");
            const diameter = Math.max(button.clientWidth, button.clientHeight);
            const radius = diameter / 2;

            circle.style.width = circle.style.height = `${diameter}px`;
            circle.style.left = `${
                event.clientX - button.offsetLeft - radius
            }px`;
            circle.style.top = `${event.clientY - button.offsetTop - radius}px`;

            circle.style.left = `${event.offsetX - radius}px`;
            circle.style.top = `${event.offsetY - radius}px`;

            circle.classList.add("ripple");

            // remove old ripple
            const ripple = button.getElementsByClassName("ripple")[0];

            if (ripple) {
                ripple.remove();
            }

            button.appendChild(circle);
        },
    },
};
</script>